var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:googleplay",
    clipPath: "url(#clip0_728_15186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0176 13.7979L18.0986 16.0159L14.5836 12.5229L18.1266 9.00194L22.0176 11.2039C22.2473 11.3338 22.4383 11.5223 22.5712 11.7502C22.7042 11.978 22.7742 12.2371 22.7742 12.5009C22.7742 12.7647 22.7042 13.0238 22.5712 13.2517C22.4383 13.4796 22.2473 13.6681 22.0176 13.7979ZM1.33661 1.42394C1.2624 1.6041 1.22434 1.79709 1.22461 1.99194V23.0089C1.22461 23.2259 1.26961 23.4279 1.34861 23.6089L12.5036 12.5219L1.33661 1.42394ZM13.5436 11.4889L16.8016 8.25094L3.44961 0.694936C3.16342 0.530472 2.8301 0.467402 2.50361 0.515936L13.5436 11.4889ZM13.5436 13.5559L2.54361 24.4889C2.84161 24.5249 3.15561 24.4729 3.44961 24.3059L16.7736 16.7659L13.5436 13.5559Z",
    fill: "#F84437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0176 13.7979L18.0986 16.0159L14.5836 12.5229L18.1266 9.00194L22.0176 11.2039C22.2473 11.3338 22.4383 11.5223 22.5712 11.7502C22.7042 11.978 22.7742 12.2371 22.7742 12.5009C22.7742 12.7647 22.7042 13.0238 22.5712 13.2517C22.4383 13.4796 22.2473 13.6681 22.0176 13.7979ZM1.33661 1.42394C1.2624 1.6041 1.22434 1.79709 1.22461 1.99194V23.0089C1.22461 23.2259 1.26961 23.4279 1.34861 23.6089L12.5036 12.5219L1.33661 1.42394ZM13.5436 11.4889L16.8016 8.25094L3.44961 0.694936C3.16342 0.530472 2.8301 0.467402 2.50361 0.515936L13.5436 11.4889Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.33661 1.42394C1.2624 1.6041 1.22434 1.79709 1.22461 1.99194V23.0089C1.22461 23.2259 1.26961 23.4279 1.34861 23.6089L12.5036 12.5219L1.33661 1.42394ZM13.5436 11.4889L16.8016 8.25094L3.44961 0.694936C3.16342 0.530472 2.8301 0.467402 2.50361 0.515936L13.5436 11.4889Z",
    fill: "#5ACF5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.33661 1.42383C1.2624 1.60399 1.22434 1.79698 1.22461 1.99183V23.0088C1.22461 23.2258 1.26961 23.4278 1.34861 23.6088L12.5036 12.5218L1.33661 1.42383Z",
    fill: "#2299F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_15186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.d88e15b86c2fcded3df6031ef6cc167f.svg";
export { ForwardRef as ReactComponent };